import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap/dist/gsap';
// eslint-disable-next-line no-unused-vars
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {
    // JavaScript to be fired on the home page

    // /**************************************************************
    // -> Pageload animation
    // **************************************************************/
    function pageExperiencesLoadAnimation() {
      const tl = gsap.timeline({ delay: 0.5, duration: 0.5 })

      tl.to('.hero-experiences .wrap-fullscreen-image', { opacity: 1 })
      .to('.hero-experiences .dark-overlay-hero', { opacity: 1 }, '>-0.15')
      .to('.hero-experiences .wrap-hero-header h1', { opacity: 1 }, '>-0.25')
      .to('.hero-experiences .wrap-hero-header a', { opacity: 1 }, '>-0.35')
    }
    pageExperiencesLoadAnimation()

    /**************************************************************
    -> Destinations intro anim on scroll
    **************************************************************/
    function inViewAnimIntroExperiences() {
      gsap.fromTo('.intro-experiences .intro-container h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.intro-experiences .intro-container',
      })

      gsap.fromTo('.intro-experiences .intro-container p' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        scrollTrigger: '.intro-experiences .intro-container',
      })

    }
    inViewAnimIntroExperiences();

    /**************************************************************
    -> Experiences quotes anim on scroll
    **************************************************************/
    function inViewAnimExperiencesQuote() {
      gsap.fromTo('.clients-say-destinations h2' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-destinations',
      })

      gsap.fromTo('.clients-say-destinations .wrap-carousel' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.25,
        duration: 0.5,
        scrollTrigger: '.clients-say-destinations h2',
      })
    }
    inViewAnimExperiencesQuote();

    /**************************************************************
    -> Destinations List anim on scroll
    **************************************************************/
    function inViewAnimListExperiences() {
      gsap.fromTo('.list-experiences .wrap-experiences-list .type-item' , 
      { opacity: 0 },
      {
        opacity: 1,
        delay: 0.5,
        duration: 0.5,
        stagger: {
          each: 0.08,
          from: 'start',
          grid: 'auto',
          ease: 'linear',
        },
        scrollTrigger: '.list-experiences .wrap-experiences-list',
      })

    }
    inViewAnimListExperiences();

    // About Quote slider
    // eslint-disable-next-line no-unused-vars
    let ExperiencesQuoteSwiper = new Swiper ('.swiper-container-destinations-clients-say', {
      loop: true,
      slidesPerView: 1,
      roundLengths: true,
      grabCursor: true,
      speed: 500,
      navigation: {
        nextEl: '.swiper-clients-say-button-next',
        prevEl: '.swiper-clients-say-button-prev',
      },
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/experiences.js